import { createContext } from 'react';


/*
Auth Context have a global state for auth
Auth has the provider that is used in AuthState to render 
  the necessary children within it.
When another component needs some variable from this context, 
  it has to import it and use the hook of useContext to get the things that the provider offers.
*/

const AuthContext = createContext();

export default AuthContext;
